export default class BaseConcreteStrategy {
    chainId;
    evmChainId;
    listeners = {};
    metadata;
    constructor(args) {
        this.evmChainId =
            'evmOptions' in args && args.evmOptions
                ? args.evmOptions.evmChainId
                : undefined;
        this.chainId = args.chainId;
        this.metadata = args.metadata;
    }
}
